function getParams(
	{
		buyerValues,
		paymentValues,
		passengersValues,
		travelReasonValues,
		otherTravelReasonValues,
	},
	{
		user,
		originGoing,
		destinationGoing,
		originReturn,
		destinationReturn,
		deviceId,
		tripGoing,
		groupGoing,
		priceGoing,
		priceReturn,
		groupReturn,
		originState,
		originPortal,
		buyerAddress,
		serviceGoing,
		serviceReturn,
		discountCoupon,
		isUpgradeGoing,
		tripPriceGoing,
		extraDataGoing,
		originIbgeCode,
		routeClassType,
		tripReturn = {},
		extraDataReturn,
		isUpgradeReturn,
		tripPriceReturn,
		destinationState,
		destinationIbgeCode,
		selectedBusSeatsGoing,
		serviceChargeSelected,
		selectedServiceCharge,
		selectedBusSeatsReturn,
		conexao,
		selectedPoltonasIda,
		selectedPoltonasVolta,
		requestNumber,
		rebookingData,
		affiliateCode,
	}
) {
	const routeClassCodeStr =
		routeClassType.isInterstate == true || routeClassType.isInterstate > 0
			? 'Interstate'
			: 'Intermunicipal'
	const passengers = passengersValues.map((passenger, idx) => {
		let birthDate = passenger[`passenger_birthdate_${idx}`]

		const parts = birthDate.split('-')

		if (parts[0].length === 2) {
			birthDate = `${parts[2]}-${parts[1]}-${parts[0]}`
		}

		return {
			name: passenger.name.name ? passenger.name.name : passenger.name,
			documentType: passenger.documenttype,
			documentNumber: passenger.documentnumber,
			birthDate,
		}
	})

	let isEligibleForBenefit = false
	let isOneClickBuy = false

	if (user) {
		isEligibleForBenefit = user.isEligibleForBenefit
		isOneClickBuy = user.muvicardData && user.muvicardData.oneClickBuy
	}

	var ticketsGoing = selectedBusSeatsGoing.map(
		(
			{
				number,
				transactionId,
				bookingCode,
				discount,
				withInsurance,
				originId,
				destinationId,
				provider,
				benefitCategory,
				benefitCategoryId,
				disembarkingTerminal,
				boardingTerminal,
				toll,
				fee,
				insurance,
				other,
				tax,
				price,
				destinationCode,
			},
			index
		) => ({
			transactionId,
			originId,
			origin: originGoing,
			originState,
			destination: destinationGoing,
			destinationState,
			withInsurance,
			originIbgeCode,
			originLocalityId: originId,
			group: groupGoing,
			...extraDataGoing,
			discount: discount,
			destinationId,
			destinationIbgeCode,
			service: serviceGoing,
			busSeatNumber: number,
			destinationLocalityId: destinationId,
			arrival: tripGoing.arrival,
			passenger: passengers[index],
			tripDate: tripGoing.departure,
			departure: tripGoing.departure,
			busCompany: tripGoing.enterprise,
			bookingTransactionId: bookingCode,
			price: {
				toll,
				fee,
				insurance,
				other,
				tax,
				price,
			},
			classCode: tripGoing.classCode,
			scheduleKey: tripGoing.scheduleKey,
			busClass: tripGoing.busClass,
			selectedPriceValue: tripPriceGoing.value,
			provider,
			benefitCategory,
			benefitCategoryId,
			IsElegibleForBenefit: isEligibleForBenefit,
			disembarkingTerminal,
			boardingTerminal,
			destinationCodeGoing: destinationCode,
		})
	)

	if (conexao.conexaoIda && conexao.conexaoIda.trecho.length) {
		var trechosAgrupados = Object.entries(
			selectedPoltonasIda.reduce((prev, curr) => {
				prev[curr.ordem]
					? prev[curr.ordem].push(curr)
					: (prev[curr.ordem] = [curr])
				return prev
			}, {})
		)
		var poltronas = []
		trechosAgrupados.map(
			([key, value]) =>
				(poltronas = [
					...poltronas,
					...value.map(
						(
							{
								number,
								transactionId,
								bookingCode,
								discount,
								withInsurance,
								conexao,
								originId,
								destinationId,
								provider,
								benefitCategory,
								benefitCategoryId,
								disembarkingTerminal,
								boardingTerminal,
								toll,
								fee,
								insurance,
								other,
								tax,
								price,
								destinationCode,
							},
							index
						) => ({
							transactionId,
							origin: conexao.origin,
							originState: conexao.originState,
							destination: conexao.destination,
							destinationState: conexao.destinationState,
							withInsurance,
							originIbgeCode: conexao.originIbgeCode,
							originLocalityId: conexao.originLocalityId,
							group: conexao.group,
							...extraDataGoing,
							discount: discount,
							destinationIbgeCode: conexao.destinationIbgeCode,
							service: serviceGoing,
							busSeatNumber: number,
							destinationLocalityId: conexao.destinationLocalityId,
							arrival: conexao.arrival,
							passenger: passengers[index],
							tripDate: conexao.departure,
							departure: conexao.departure,
							busCompany: conexao.enterprise,
							bookingTransactionId: bookingCode,
							busClass: conexao.busClass,
							classCode: conexao.classCode,
							scheduleKey: conexao.scheduleKey,
							selectedPriceValue: tripPriceGoing.value,
							originId,
							destinationId,
							provider,
							benefitCategory,
							benefitCategoryId,
							IsElegibleForBenefit: isEligibleForBenefit,
							disembarkingTerminal,
							boardingTerminal,
							price: {
								toll,
								fee,
								insurance,
								other,
								tax,
								price,
							},
							destinationCodeGoing: destinationCode,
						})
					),
				])
		)
		ticketsGoing = poltronas
	}

	let ticketsReturn = selectedBusSeatsReturn.map(
		(
			{
				number,
				transactionId,
				bookingCode,
				discount,
				withInsurance,
				originId,
				destinationId,
				provider,
				benefitCategory,
				benefitCategoryId,
				disembarkingTerminal,
				boardingTerminal,
				toll,
				fee,
				insurance,
				other,
				tax,
				price,
				destinationCode,
			},
			index
		) => ({
			withInsurance,
			transactionId,
			discount: discount,
			...extraDataReturn,
			group: groupReturn,
			originId,
			destinationId,
			origin: originReturn,
			destination: destinationReturn,
			busSeatNumber: number,
			service: serviceReturn,
			arrival: tripReturn.arrival,
			passenger: passengers[index],
			originState: destinationState,
			destinationState: originState,
			tripDate: tripReturn.departure,
			departure: tripReturn.departure,
			bookingTransactionId: bookingCode,
			busCompany: tripReturn.enterprise,
			price: price,
			classCode: tripReturn.classCode,
			scheduleKey: tripReturn.scheduleKey,
			busClass: tripReturn.busClass,
			selectedPriceValue: tripPriceReturn.value,
			provider,
			benefitCategory,
			benefitCategoryId,
			IsElegibleForBenefit: isEligibleForBenefit,
			disembarkingTerminal,
			boardingTerminal,
			price: {
				toll,
				fee,
				insurance,
				other,
				tax,
				price,
			},
			destinationCodeReturn: destinationCode,
		})
	)

	if (conexao.conexaoVolta && conexao.conexaoVolta.trecho.length) {
		var trechosAgrupados = Object.entries(
			selectedPoltonasVolta.reduce((prev, curr) => {
				prev[curr.ordem]
					? prev[curr.ordem].push(curr)
					: (prev[curr.ordem] = [curr])
				return prev
			}, {})
		)
		var poltronas = []
		trechosAgrupados.map(
			([key, value]) =>
				(poltronas = [
					...poltronas,
					...value.map(
						(
							{
								number,
								transactionId,
								bookingCode,
								discount,
								withInsurance,
								conexao,
								originId,
								destinationId,
								provider,
								benefitCategory,
								benefitCategoryId,
								disembarkingTerminal,
								boardingTerminal,
								toll,
								fee,
								insurance,
								other,
								tax,
								price,
								destinationCode,
							},
							index
						) => ({
							transactionId,
							origin: conexao.origin,
							originState: conexao.originState,
							destination: conexao.destination,
							destinationState: conexao.destinationState,
							withInsurance,
							originIbgeCode: conexao.originIbgeCode,
							originLocalityId: conexao.originLocalityId,
							group: conexao.group,
							...extraDataReturn,
							discount: discount,
							destinationIbgeCode: conexao.destinationIbgeCode,
							service: serviceReturn,
							busSeatNumber: number,
							destinationLocalityId: conexao.destinationLocalityId,
							arrival: conexao.arrival,
							passenger: passengers[index],
							tripDate: conexao.departure,
							departure: conexao.departure,
							busCompany: conexao.enterprise,
							bookingTransactionId: bookingCode,
							busClass: conexao.busClass,
							classCode: conexao.classCode,
							scheduleKey: conexao.scheduleKey,
							selectedPriceValue: tripPriceReturn.value,
							originId,
							destinationId,
							provider,
							benefitCategory,
							benefitCategoryId,
							IsElegibleForBenefit: isEligibleForBenefit,
							disembarkingTerminal,
							boardingTerminal,
							price: {
								toll,
								fee,
								insurance,
								other,
								tax,
								price,
							},
							destinationCodeReturn: destinationCode,
						})
					),
				])
		)
		ticketsReturn = poltronas
	}

	const params = {
		ticketsGoing,
		ticketsReturn,
		creditCard: {
			cardId: paymentValues.cardId,
			saveCard: paymentValues.savecard,
			cardNumber: paymentValues.cardNumber,
			securityCode: paymentValues.securityCode,
			cardholderName: paymentValues.cardPrintedName,
			expirationYear: paymentValues.cardYearValidity,
			cardNumberToken: paymentValues.cardNumberToken,
			expirationMonth: paymentValues.cardMonthValidity,
			numberOfInstallments: paymentValues.installments || 0,
		},
		debitCard: {
			cardNumber: paymentValues.cardNumber,
			securityCode: paymentValues.securityCode,
			cardholderName: paymentValues.cardPrintedName,
			expirationYear: paymentValues.cardYearValidity,
			expirationMonth: paymentValues.cardMonthValidity,
		},
		muvicard: {
			cpf: paymentValues.muvicardCpf,
			password: paymentValues.password,
			oneClickBuy: isOneClickBuy,
			numberOfInstallments: paymentValues.installments || 0,
			activateOneClickMuvicard: paymentValues.activateOneClickMuvicard,
		},
		deviceId,
		originPortal,
		isUpgradeGoing,
		isUpgradeReturn,
		buyerRg: buyerValues.rg,
		buyerBirthday: buyerValues.buyer_birthdate,
		buyerCpf: buyerValues.cpf,
		buyerName: buyerValues.name,
		buyerCity: buyerAddress.city,
		buyerEmail: buyerValues.email,
		buyerState: buyerAddress.state,
		buyerStreet: buyerAddress.street,
		busCompany: tripGoing.enterprise,
		routeClassCode: routeClassCodeStr,
		buyerZipCode: buyerValues.zipcode,
		busClassGoing: tripGoing.busClass,
		classCodeGoing: tripGoing.classCode,
		busClassReturn: tripReturn.busClass,
		classCodeReturn: tripReturn.classCode,
		scheduleKeyGoing: tripGoing.scheduleKey,
		raceDateGoing: tripGoing.raceDate,
		discountCouponCode: discountCoupon.code,
		selectedPriceIdGoing: tripPriceGoing.id,
		scheduleKeyReturn: tripReturn.scheduleKey,
		raceDateReturn: tripReturn.raceDate,
		selectedPriceIdReturn: tripPriceReturn.id,
		buyerPhoneNumber: buyerValues.phonenumber,
		paymentMethod: !paymentValues.paymentMethod
			? 'creditCard'
			: paymentValues.paymentMethod,
		buyerNeighborhood: buyerAddress.neighborhood,
		purchaseOption: serviceChargeSelected
			? serviceChargeSelected.purchaseOption
			: selectedServiceCharge,
		feeGoing: priceGoing.fee,
		taxGoing: priceGoing.tax,
		tollGoing: priceGoing.toll,
		insuranceGoing: priceGoing.insurance,
		lineCodeGoing: extraDataGoing.lineCode,
		destinationCodeGoing: extraDataGoing.destinationCode,
		feeReturn: priceReturn.fee,
		taxReturn: priceReturn.tax,
		tollReturn: priceReturn.toll,
		insuranceReturn: priceReturn.insurance,
		lineCodeReturn: extraDataReturn.lineCode,
		destinationCodeReturn: extraDataReturn.destinationCode,
		grupoIda: conexao.conexaoIdaId,
		grupoVolta: conexao.conexaoVoltaId,
		requestNumber: requestNumber,
		rebookingTicketId: rebookingData.rebookingTicketId || null,
		affiliateCode: affiliateCode,
		travelReason: travelReasonValues,
		otherTravelReason: otherTravelReasonValues,
		purchaseForCustomerId: rebookingData.purchaseForCustomerId,
	}

	return params
}

export function groupTrips(selectedPoltonas) {
	return Object.entries(
		selectedPoltonas.reduce((prev, curr) => {
			prev[curr.ordem]
				? prev[curr.ordem].push(curr)
				: (prev[curr.ordem] = [curr])
			return prev
		}, {})
	)
}

const ticketSaleHelper = { getParams, groupTrips }

export default ticketSaleHelper
